import React from 'react'

interface ATLoaderContainerProps {
  children: React.ReactElement | null
}

const ATLoaderContainer: React.FC<ATLoaderContainerProps> = ({ children }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center loader-container h-100"
      style={{
        flexGrow: 1,
      }}
    >
      {children}
    </div>
  )
}

export default ATLoaderContainer
